import { FC } from 'react'
import { useGalleryDeal } from '../../contexts'

import { ClientGalleryPageActionsController } from './ClientGalleryPageActions.controller'
import { RescheduleOrderModuleProvider } from 'components/common/RescheduleOrder'

/**
 * Client gallery page actions.
 * 
 * @example <ClientGalleryPageActions />
 */
export const ClientGalleryPageActions: FC = () => {
  const { dealData } = useGalleryDeal()

  return (
    <RescheduleOrderModuleProvider orderId={dealData?.id}>
      <ClientGalleryPageActionsController />
    </RescheduleOrderModuleProvider>
  )
}
